import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface WorksheetZoneTotal {
  zona: string;
  totale: number;
}

export interface WorksheetZoneTotalsDialogData {
  totaliPerZona: WorksheetZoneTotal[];
  totaleComplessivo: number;
}

@Component({
  providers: [provideTranslocoScope('receipts')],
  selector: 'rev-receipts-worksheet-zone-totals-dialog-component',
  imports: [TranslocoPipe, TranslocoCurrencyPipe, MatButtonModule, MatDialogModule],
  templateUrl: './receipts-worksheet-zone-totals-dialog-component.html',
  styleUrl: './receipts-worksheet-zone-totals-dialog-component.scss',
})
export class ReceiptsWorksheetZoneTotalsDialogComponent {
  readonly data = inject<WorksheetZoneTotalsDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ReceiptsWorksheetZoneTotalsDialogComponent>);

  close(): void {
    this.dialogRef.close();
  }
}
